function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 11,
  fill: "#ff3945"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16.812 9.28a3.353 3.353 0 00-3.2-3.28 3.183 3.183 0 00-2.729 1.574A3.067 3.067 0 008.222 6a3.193 3.193 0 00-2.19.95A3.591 3.591 0 005.02 9.28a3.382 3.382 0 00.1 1.246 5.346 5.346 0 001.639 2.734L10.881 17l4.192-3.74a5.347 5.347 0 001.638-2.734 3.39 3.39 0 00.101-1.246zm-.544 1.142a4.89 4.89 0 01-1.5 2.5l-3.885 3.466-3.819-3.466a4.893 4.893 0 01-1.5-2.5 2.955 2.955 0 01-.095-1.07v-.023a2.91 2.91 0 012.753-2.874 2.667 2.667 0 012.451 1.71l.21.5.21-.5a2.749 2.749 0 012.517-1.71 2.92 2.92 0 012.752 2.9 2.952 2.952 0 01-.094 1.071z",
  fill: "#fff"
});

function SvgIconHeart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22"
  }, props), _ref, _ref2);
}

export default SvgIconHeart;